interface Comparator<T> {
	(a : T, b : T) : number;
}

export function compare<T extends unknown>(valA : T, valB : T) {
	if (valA === null || valA === '' || valA === undefined) {
		return valA === valB ? 0 : -1;
	}

	if (valB === null || valB === '' || valB === undefined) {
		return valA === valB ? 0 : 1;
	}

	let cmpA : any = valA;
	let cmpB : any = valB;

	if (typeof valA === 'string' && typeof valB === 'string') {
		if (!Number.isNaN(parseInt(valA, 10)) && !Number.isNaN(parseInt(valB, 10))) {
			cmpA = parseInt(valA, 10);
			cmpB = parseInt(valB, 10);
		} else {
			cmpA = valA.toLowerCase();
			cmpB = valB.toLowerCase();

			// Do utf8 umlaut compatible string comparison if supported by the browser
			if (typeof cmpA.localeCompare === 'function') {
				return cmpA.localeCompare(cmpB);
			}
		}
	}

	// Do the sorting (JS is able to compare numbers AND string with the "<", ">" operators
	return cmpA > cmpB ? 1 : (cmpA < cmpB ? -1 : 0);
}

export function comparingBy<T, K extends keyof T>(_data : T, comparator : Comparator<T[K]>, key : K) : Comparator<T> {
	return (a, b) => comparator(a[key], b[key]);
}

export function inverted<T>(compare : Comparator<T>) : Comparator<T> {
	return (a, b) => compare(b, a);
}



// WEBPACK FOOTER //
// typescript://../clientlibs/js/lib/util/compare.ts